import { Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberUtils } from '../../../utils/phone-number-utils';

@Pipe({
  name: 'formattedPhoneNumber',
  standalone: true
})
export class FormattedPhoneNumberPipe implements PipeTransform {
  transform(value: string, countryCode: string): string {
    return PhoneNumberUtils.formatNumberWithLibPhoneNumber(value, countryCode);
  }
}
